// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"5179553f","170":"001e35fc","485":"aad8a1af","501":"a3b1b504"}[chunkId] + ".chunk.js";
};